/**
 * @author       luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright    Copyright (c) 2024, Zumper
 * @description  Reducer for lifestyles module
 */

import { falseReducer, payloadReducer, trueReducer } from '@zcode/reducers'
import type { CurrentSearch } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { type ExtractActions, type Values, handleAction, handleActions } from 'redux-actions'
import type * as actions from '../actions'
import {
  DONE_FETCHING_CITY_LIFESTYLES,
  ERROR_FETCHING_CITY_LIFESTYLES,
  RECEIVE_CITY_LIFESTYLES,
  START_FETCHING_CITY_LIFESTYLES,
} from '../constants'

type Actions = ExtractActions<Values<typeof actions>>

export const cityLifestylesAllowedList = [
  DONE_FETCHING_CITY_LIFESTYLES,
  ERROR_FETCHING_CITY_LIFESTYLES,
  RECEIVE_CITY_LIFESTYLES,
  START_FETCHING_CITY_LIFESTYLES,
] as const satisfies ReadonlyArray<Actions['type']>

declare const shouldBeEmpty: Exclude<Actions['type'], (typeof cityLifestylesAllowedList)[number]>
false && (shouldBeEmpty satisfies never)

export const cityLifestylesReducer = combineReducers<CurrentSearch['cityLifestyles'], Actions>({
  fetching: handleActions(
    {
      [START_FETCHING_CITY_LIFESTYLES]: trueReducer,
      [DONE_FETCHING_CITY_LIFESTYLES]: falseReducer,
      [ERROR_FETCHING_CITY_LIFESTYLES]: falseReducer,
    },
    false
  ),
  data: handleAction<
    CurrentSearch['cityLifestyles']['data'],
    Actions,
    typeof RECEIVE_CITY_LIFESTYLES
  >(RECEIVE_CITY_LIFESTYLES, payloadReducer, null),
})
